import { Controller } from "@hotwired/stimulus"

// Whole numbers only: blocks the characters a number field otherwise accepts
// (".", ",", "e", "+", "-") and trims pasted decimals to their integer part.
// Server-side validation stays the backstop.
export default class extends Controller {
  static blockedKeys = [".", ",", "e", "E", "+", "-"]

  keydown(event) {
    if (this.constructor.blockedKeys.includes(event.key)) event.preventDefault()
  }

  clean() {
    const integer = this.element.value.match(/\d+/)?.[0] ?? ""
    if (this.element.value !== integer) this.element.value = integer
  }
}
